import { AxiosResponse } from 'axios'
import request from '../axios'

export const authenticationUser = async (
    finalFormData: FormData
): Promise<AxiosResponse<any>> => {
    const response = await request.post(
        '/api/authentication-user',
        finalFormData
    )
    return response.data
}
